import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    Dialog,
    DialogTitle,
    DialogContent,
    Snackbar,
    Alert,
    DialogContentText,
    DialogActions,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from "@mui/material";
import { TbCalendarOff } from "react-icons/tb";
import { BiShow } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { useGetAllSalesQuery } from "../../../redux/slices/admin/payment/paymentSlince.js";
import { useDeleteSaleMutation } from "../../../redux/slices/seller/sale/deleteSale.js";
import { useOutletContext, useLocation } from "react-router-dom";
import { Pagination } from "@mui/material";
import "../../../styles/admin.css/payments-css/total-payments.css";

export default function TotalPayments() {
    const { sidebarOpen } = useOutletContext();
    const location = useLocation();
    const highlightId = location.state?.highlightId;
    const isRefundPage = location.pathname.includes("refund");
    
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [selectedSale, setSelectedSale] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);

    const { data, isLoading, refetch } = useGetAllSalesQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    const paymentsData = data?.data || [];

    useEffect(() => {
        if (highlightId) {
            const sale = paymentsData.find(s => s.id === highlightId);
            if (sale) {
                setOpenRow(sale.id);
                window.history.replaceState({}, document.title);
            }
        }
    }, [highlightId, paymentsData]);

    const [deleteSale] = useDeleteSaleMutation();
    const [search, setSearch] = useState("");
    const [numberSearch, setNumberSearch] = useState("");
    const [openRow, setOpenRow] = useState(null);

    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastSeverity, setToastSeverity] = useState("error");

    const [paymentMethodFilter, setPaymentMethodFilter] = useState("all");
    const [customerFilter, setCustomerFilter] = useState("all");
    const [dateFilter, setDateFilter] = useState("");

    const formatCarPlate = (plate) => {
        if (!plate) return "";
        return plate.replace(/^(\d{2})([A-Z]+)(\d{3})$/, "$1-$2-$3");
    };


    const filteredPayments = paymentsData.filter(emp => {
        const methodMatch =
            paymentMethodFilter === "all" ||
            emp.paymentType === paymentMethodFilter;

        let customerMatch = true;
        if (customerFilter === "Qeydiyat nisani") {
            customerMatch = emp.isBuyCar === true;
        } else if (customerFilter === "Əl ilə alındı") {
            customerMatch = emp.isBuyCar === false;
        } else if (customerFilter === "Umico") {
            customerMatch = emp.isUmico === true;
        }

        let dateMatch = true;
        if (dateFilter) {
            const paymentDate = emp.createdAt ? new Date(emp.createdAt).toISOString().split('T')[0] : "";
            dateMatch = paymentDate === dateFilter;
        }

        const searchMatch =
            (emp.sellerName || "").toLowerCase().includes(search.toLowerCase()) ||
            (emp.carPlate || "").toLowerCase().includes(search.toLowerCase()) ||
            (emp.paymentType || "").toLowerCase().includes(search.toLowerCase());

        let numberMatch = true;
        if (numberSearch) {
            const cleanSearch = numberSearch.replace(/^#+/, "").trim();
            const displayNo = String(emp.serialNo || emp.id).padStart(4, "0");
            numberMatch = displayNo.includes(cleanSearch) || String(emp.serialNo || emp.id).includes(cleanSearch);
        }

        return methodMatch && customerMatch && dateMatch && searchMatch && numberMatch;
    });


    const totalPages = Math.ceil(filteredPayments.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedPayments = filteredPayments.slice(startIndex, startIndex + itemsPerPage);

    const handleShowClick = (emp) => {
        setOpenRow(openRow === emp.id ? null : emp.id);
    };

    const confirmDelete = async () => {
        if (!selectedSale) return;
        try {
            setIsDeleting(true);
            await deleteSale(selectedSale.id).unwrap();
            refetch();
            setDeleteDialogOpen(false);
            setSelectedSale(null);
            setToastMessage("Satış uğurla geri qaytarıldı");
            setToastSeverity("success");
            setToastOpen(true);
        } catch (error) {
            console.error(error);
            setToastMessage("Geri qaytarma zamanı xəta baş verdi");
            setToastSeverity("error");
            setToastOpen(true);
        } finally {
            setIsDeleting(false);
        }
    };

    React.useEffect(() => {
        setPage(1);
    }, [search, numberSearch, paymentMethodFilter, customerFilter, dateFilter]);
    return (
        <Box className={`total-payments-container ${sidebarOpen ? "sidebar-open" : ""}`}>

            <Box className="total-payments-header">
                <Box className="total-payments-title">
                    <Typography style={{ color: "#545A61" }}>
                        {isRefundPage ? "Geri qaytarma" : "Ümumi ödəniş tarixçəsi"}
                    </Typography>
                    <Divider className="total-payments-divider" />
                </Box>

                <Box style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20, gap: 10 }}>
                    <Box style={{ display: 'flex', gap: 10 }}>


                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px solid rgba(0,0,0,0.23)",
                                borderRadius: "4px",
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: "rgba(0,0,0,0.04)"
                                }
                            }}
                            onClick={() => setDateFilter("")}
                        >
                            <TbCalendarOff size={18} />
                        </Box>


                        <FormControl size="small">
                            <TextField
                                type="date"
                                size="small"
                                label="Tarix"
                                InputLabelProps={{ shrink: true }}
                                value={dateFilter}
                                onChange={(e) => setDateFilter(e.target.value)}
                                style={{ minWidth: 160 }}
                            />
                        </FormControl>



                        <FormControl size="small">
                            <InputLabel>Ödəniş Üsulu</InputLabel>
                            <Select
                                value={paymentMethodFilter}
                                label="Ödəniş Üsulu"
                                onChange={(e) => { setPaymentMethodFilter(e.target.value); }}
                                style={{ minWidth: 140 }}
                            >
                                <MenuItem value="all">Bütün Qeydlər</MenuItem>
                                <MenuItem value="Kart">Kart</MenuItem>
                                <MenuItem value="Nağd">Nağd</MenuItem>
                                <MenuItem value="Kart və nağd">Kart və nağd</MenuItem>
                                <MenuItem value="POS-terminal">POS-terminal</MenuItem>
                                <MenuItem value="Nəğd/POS-terminal">Nəğd/POS-terminal</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl size="small">
                            <InputLabel>Müştəri</InputLabel>
                            <Select
                                value={customerFilter}
                                label="Müştəri"
                                onChange={(e) => { setCustomerFilter(e.target.value); }}
                                style={{ minWidth: 140 }}
                            >
                                <MenuItem value="all">Bütün Qeydlər</MenuItem>
                                <MenuItem value="Qeydiyat nisani">Qeydiyat nisani</MenuItem>
                                <MenuItem value="Əl ilə alındı">Əl ilə alındı</MenuItem>
                                <MenuItem value="Umico">Umico</MenuItem>
                            </Select>
                        </FormControl>


                    </Box>

                    <Box sx={{ display: "flex", gap: "10px" }}>
                        <TextField
                            size="small"
                            placeholder="#No"
                            sx={{ width: "100px" }}
                            value={numberSearch}
                            onChange={(e) => { setNumberSearch(e.target.value); }}
                        />
                        <TextField
                            size="small"
                            placeholder="Axtar..."
                            className="total-payments-search"
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); }}
                        />
                    </Box>
                </Box>
            </Box>

            <TableContainer component={Paper} className="total-payments-table">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>#No</strong></TableCell>
                            <TableCell><strong>Satışı edən</strong></TableCell>
                            <TableCell><strong>Ödəniş Üsulu</strong></TableCell>
                            <TableCell><strong>Müştəri</strong></TableCell>
                            <TableCell><strong>Satış Tarixi</strong></TableCell>
                            <TableCell><strong>Seçimlər</strong></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center">Yüklənir...</TableCell>
                            </TableRow>
                        ) : paginatedPayments.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center">Məlumat tapılmadı</TableCell>
                            </TableRow>
                        ) : (
                            paginatedPayments.map((emp, index) => (
                                <React.Fragment key={emp.paymentId}>
                                    <TableRow className={highlightId === emp.id ? 'highlight-row' : ''}>
                                        <TableCell>{"#" + String(emp.serialNo || emp.id).padStart(4, "0")}</TableCell>

                                        <TableCell>{emp.sellerName}</TableCell>
                                        <TableCell>{emp.paymentType}</TableCell>
                                        <TableCell>
                                            <strong>
                                                {emp.isBuyCar
                                                    ? formatCarPlate(emp.carPlate)
                                                    : emp.isUmico
                                                        ? "Umico"
                                                        : "Əl ilə alındı"}
                                            </strong>
                                        </TableCell>

                                        <TableCell>{emp.createdAt ? new Date(emp.createdAt).toLocaleString() : "-"}</TableCell>
                                        <TableCell className="manage-wrapper">
                                            <Button size="small" variant="contained" className="total-payments-btn" onClick={() => handleShowClick(emp)}><BiShow style={{ width: "24px", height: "24px" }} /></Button>
                                            {isRefundPage && (
                                                <Button size="small" variant="contained" className="btnn-delete" onClick={() => {
                                                    setSelectedSale(emp);
                                                    setDeleteDialogOpen(true);
                                                }}><MdDeleteOutline style={{ width: "24px", height: "24px" }} /></Button>
                                            )}
                                        </TableCell>
                                    </TableRow>

                                    {openRow === emp.id && (
                                        <TableRow>
                                            <TableCell colSpan={6} className="total-payments-expanded-cell">
                                                <Box className="payment-detailss">
                                                    <TableContainer component={Paper} style={{ boxShadow: "none", marginBottom: "20px" }}>
                                                        <Table size="small" className="payment-table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell><strong>Məhsul</strong></TableCell>
                                                                    <TableCell><strong>Qiymət</strong></TableCell>
                                                                    <TableCell><strong>Endirim</strong></TableCell>
                                                                    <TableCell><strong>Maya</strong></TableCell>
                                                                    <TableCell><strong>Miqdar</strong></TableCell>
                                                                    <TableCell><strong>Kod</strong></TableCell>
                                                                    <TableCell><strong>Yanacaq Növü</strong></TableCell>
                                                                    <TableCell><strong>Ümumi Qiymət</strong></TableCell>
                                                                </TableRow>
                                                            </TableHead>


                                                            <TableBody>
                                                                {emp.items?.map((prod, idx) => {

                                                                    const isOil = prod.subcategoryName === "Motor yağı" || prod.subcategoryName === "Transmissiya yağı";

                                                                    return (
                                                                        <TableRow key={idx}>
                                                                            <TableCell>{prod.productName ?? prod.serviceName ?? '-'}</TableCell>
                                                                            <TableCell>
                                                                                {prod.sellPriceAtMoment != null
                                                                                    ? prod.sellPriceAtMoment
                                                                                    : '-'}₼
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                {prod.discountAmount ? `${prod.discountAmount}₼` : '-'}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {prod.costPriceAtMoment ? `${prod.costPriceAtMoment}₼` : '-'}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {prod.productName == null
                                                                                    ? "Xidmət"
                                                                                    : `${prod.quantity} ${isOil ? "Litr" : "Ədəd"}`}

                                                                            </TableCell>
                                                                            <TableCell>{prod.code ? prod.code : "-"}</TableCell>
                                                                            <TableCell>{prod.fuelType ? prod.fuelType : "-"}</TableCell>
                                                                            <TableCell>{prod.totalPrice}₼</TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                            </TableBody>

                                                        </Table>
                                                    </TableContainer>

                                                    <TableContainer component={Paper} style={{ boxShadow: "none" }}>
                                                        <Table size="small" className="payment-table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell><strong>Ödənildi</strong></TableCell>
                                                                    {emp.paymentType === "Kart və nağd" ? (
                                                                        <>
                                                                            <TableCell><strong>Kart</strong></TableCell>
                                                                            <TableCell><strong>Nağd</strong></TableCell>
                                                                        </>
                                                                    ) : emp.paymentType === "Naxd/POS-terminal" ? (
                                                                        <>
                                                                            <TableCell><strong>POS-terminal</strong></TableCell>
                                                                            <TableCell><strong>Nağd</strong></TableCell>
                                                                        </>
                                                                    ) : (
                                                                        <TableCell><strong>{emp.paymentType}</strong></TableCell>
                                                                    )}
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell>{emp.totalSalePrice}₼</TableCell>
                                                                    {emp.paymentType === "Kart və nağd" ? (
                                                                        <>
                                                                            <TableCell>{emp.card}₼</TableCell>
                                                                            <TableCell>{emp.cash}₼</TableCell>
                                                                        </>
                                                                    ) : emp.paymentType === "Naxd/POS-terminal" ? (
                                                                        <>
                                                                            <TableCell>{emp.card}₼</TableCell>
                                                                            <TableCell>{emp.cash}₼</TableCell>
                                                                        </>
                                                                    ) : (
                                                                        <TableCell>{(emp.paymentType === "Kart" || emp.paymentType === "POS-terminal") ? emp.card : emp.cash}₼</TableCell>
                                                                    )}
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>



                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {filteredPayments.length > itemsPerPage && (
                <Box sx={{ display: 'flex', justifyContent: 'right', p: 3, mt: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => {
                            setPage(value);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                    />
                </Box>
            )}

            <Dialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>
                    {selectedSale && (
                        <>
                            #{String(selectedSale.serialNo || selectedSale.id).padStart(4, "0")} nömrəli satışın geri qaytarılması
                        </>
                    )}
                </DialogTitle>

                <DialogContent dividers>

                    {selectedSale && (
                        <>
                            <Typography color="error" sx={{ mb: 3, fontWeight: "bold" }}>
                                Bu əməliyyat geri qaytarıla bilməz.
                                Geri qaytarmaq istədiyinizdən əminsiniz?
                            </Typography>

                            {/* PRODUCT DETAIL TABLE */}
                            <TableContainer component={Paper} sx={{ boxShadow: "none", mb: 3 }}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Məhsul</strong></TableCell>
                                            <TableCell><strong>Qiymət</strong></TableCell>
                                            <TableCell><strong>Endirim</strong></TableCell>
                                            <TableCell><strong>Maya</strong></TableCell>
                                            <TableCell><strong>Miqdar</strong></TableCell>
                                            <TableCell><strong>Kod</strong></TableCell>
                                            <TableCell><strong>Yanacaq Növü</strong></TableCell>
                                            <TableCell><strong>Ümumi Qiymət</strong></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {selectedSale.items?.map((prod, idx) => {

                                            const isOil =
                                                prod.subcategoryName === "Motor yağı" ||
                                                prod.subcategoryName === "Transmissiya yağı";

                                            return (
                                                <TableRow key={idx}>
                                                    <TableCell>
                                                        {prod.productName ?? prod.serviceName ?? '-'}
                                                    </TableCell>

                                                    <TableCell>
                                                        {prod.sellPriceAtMoment != null
                                                            ? prod.sellPriceAtMoment
                                                            : '-'}₼
                                                    </TableCell>

                                                    <TableCell>
                                                        {prod.discountAmount
                                                            ? `${prod.discountAmount}₼`
                                                            : '-'}
                                                    </TableCell>

                                                    <TableCell>
                                                        {prod.costPriceAtMoment
                                                            ? `${prod.costPriceAtMoment}₼`
                                                            : '-'}
                                                    </TableCell>

                                                    <TableCell>
                                                        {prod.productName == null
                                                            ? "Xidmət"
                                                            : `${prod.quantity} ${isOil ? "Litr" : "Ədəd"}`}
                                                    </TableCell>

                                                    <TableCell>
                                                        {prod.code ? prod.code : "-"}
                                                    </TableCell>

                                                    <TableCell>
                                                        {prod.fuelType ? prod.fuelType : "-"}
                                                    </TableCell>

                                                    <TableCell>
                                                        {prod.totalPrice}₼
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* PAYMENT DETAIL TABLE */}
                            <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Ödənildi</strong></TableCell>

                                            {selectedSale.paymentType === "Kart və nağd" ? (
                                                <>
                                                    <TableCell><strong>Kart</strong></TableCell>
                                                    <TableCell><strong>Nağd</strong></TableCell>
                                                </>
                                            ) : (
                                                <TableCell>
                                                    <strong>{selectedSale.paymentType}</strong>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                {selectedSale.totalSalePrice}₼
                                            </TableCell>

                                            {selectedSale.paymentType === "Kart və nağd" ? (
                                                <>
                                                    <TableCell>{selectedSale.card}₼</TableCell>
                                                    <TableCell>{selectedSale.cash}₼</TableCell>
                                                </>
                                            ) : (
                                                <TableCell>
                                                    {selectedSale.paymentType === "Kart"
                                                        ? selectedSale.card
                                                        : selectedSale.cash}₼
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => setDeleteDialogOpen(false)}
                        variant="outlined"
                        disabled={isDeleting}
                    >
                        Xeyr
                    </Button>

                    <Button
                        onClick={confirmDelete}
                        color="error"
                        variant="contained"
                        disabled={isDeleting}
                    >
                        {isDeleting ? "Geri qaytarılır..." : "Bəli, geri qaytar"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={toastOpen}
                autoHideDuration={4000}
                onClose={() => setToastOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setToastOpen(false)}
                    severity={toastSeverity}
                    sx={{ width: '100%' }}
                >
                    {toastMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
}
